import { render, staticRenderFns } from "./minimal-schedules.vue?vue&type=template&id=3f6f3bb2&scoped=true"
import script from "./minimal-schedules.vue?vue&type=script&lang=js"
export * from "./minimal-schedules.vue?vue&type=script&lang=js"
import style0 from "./minimal-schedules.vue?vue&type=style&index=0&id=3f6f3bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6f3bb2",
  null
  
)

export default component.exports